import * as React from 'react';
import styled from 'styled-components';
import { ArrowNavigation as Arrow } from './carousel-navigation-parts/arrow-navigation';
import { Dots } from './carousel-navigation-parts/dots-navigation';
import { IBaseComponentProps } from '../../../../types';
import { ListIterator } from '../../../../../utils';

export interface ICarouselNavigationProps extends IBaseComponentProps<HTMLDivElement> {
    itemsIterator: ListIterator<React.Key>;
    activeKey?: React.Key;
    type?: 'arrow' | 'dots';
    isHorizontal: boolean;
    loop: boolean;
    indicatorPosition?: 'left' | 'right';
}

const NavigationWrapper = styled.div.attrs(() => ({
    className: String('ap-carousel-navigationWrapper')
}))`
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
`;

export function CarouselNavigation(props: ICarouselNavigationProps) {
    const { type, indicatorPosition, activeKey, itemsIterator, isHorizontal, loop } = props;
    return (
        <NavigationWrapper className={'ap-carousel-navigation'}>
            {type === 'arrow'
                ? (
                    <Arrow
                        loop={loop}
                        isHorizontal={isHorizontal}
                        itemsIterator={itemsIterator}
                        indicatorPosition={indicatorPosition} />
                )
                : (
                    <Dots
                        isHorizontal={isHorizontal}
                        activeKey={activeKey}
                        itemsIterator={itemsIterator}
                        indicatorPosition={indicatorPosition} />
                )
            }
        </NavigationWrapper>
    );
}

CarouselNavigation.defaultProps = {
    navigationType: 'dots'
};
